import { render, staticRenderFns } from "./TransHoldpage.vue?vue&type=template&id=75436df2&scoped=true&"
import script from "./TransHoldpage.vue?vue&type=script&lang=js&"
export * from "./TransHoldpage.vue?vue&type=script&lang=js&"
import style0 from "./TransHoldpage.vue?vue&type=style&index=0&id=75436df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75436df2",
  null
  
)

export default component.exports